import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import Paper from "../components/ui-library/Paper/Paper";
import history from "../modules/history";
import { isStudyEnrolled } from "../modules/login";
import { getUnauthorizedStudyStatus } from "../modules/utils";
import Img403 from "../assets/svg/403.svg";

const StyledContent = styled.div`
  background-color: ${(props) => props?.theme?.bg};
  color: ${(props) => props?.theme?.fg};
  width: 100%;
  min-height: 100vh;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease;

  &.active {
    padding-left: 160px;
  }
  @media (max-width: 1024px) {
    padding: 0rem;
  }
`;

const Image = styled.img`
  height: 282px;

  @media (max-width: 768px) {
    height: 179px;
  }
`;

const StyledHeading = styled.span`
  font-size: 2.5rem;
  margin-top: 45px;
  margin-bottom: 14px;
  font-weight: 600;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 1.5rem;
  }
`;

const InfoLabel = styled.span`
  text-align: center;
`;

const AccessDenied = (props) => {
  const { studies } = props;

  const { t } = useTranslation();

  useEffect(() => {
    if (studies) {
      const studyId = studies[0]?.studyId?.toLowerCase();
      const studyStatusId = studies[0]?.status;
      const unauthorizedStudyStatus = getUnauthorizedStudyStatus(studyId);
      const listOfUnauthorizedStudyStatus = unauthorizedStudyStatus.map(
        (unauthorizedStatus) => unauthorizedStatus.id
      );

      if (
        listOfUnauthorizedStudyStatus.find(
          (unauthorizedStatusId) => unauthorizedStatusId === studyStatusId
        )
      ) {
        return;
      }

      if (isStudyEnrolled(studyId, studies, unauthorizedStudyStatus)) {
        history.push("/study");
      }
    }
  }, [studies]);

  return (
    <StyledContent id="content" className="container-fluid">
      <div className="row">
        <Paper header={t("appText.accessDenied.title")}>
          <div
            className="h-100 w-100 d-flex flex-column align-items-center justify-content-center"
            style={{ minHeight: 400 }}
          >
            <Image
              src={Img403}
              alt={t("appText.accessDenied.message", {
                study: studies && studies[0]?.code,
              })}
            />
            <StyledHeading>
              {t("appText.accessDenied.message", {
                study: studies && studies[0]?.code,
              })}
            </StyledHeading>
            <InfoLabel>{t("appText.accessDenied.info")}</InfoLabel>
          </div>
        </Paper>
      </div>
    </StyledContent>
  );
};

const mapStateToProps = (state) => {
  const {
    loginReducer: { studies },
  } = state;
  return { studies: studies };
};

export default connect(mapStateToProps, {})(AccessDenied);
